"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "custom-field-wrapper"
  }, [_c("van-field", _vm._b({
    staticClass: "custom-field",
    attrs: {
      readonly: "",
      clickable: "",
      name: "picker",
      placeholder: _vm.placeholder
    },
    on: {
      click: function click($event) {
        _vm.showPicker = true;
      }
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, "van-field", _vm.$attrs, false)), _c("van-icon", {
    attrs: {
      name: "arrow-down",
      size: "14"
    }
  })], 1), _c("van-popup", {
    attrs: {
      overlay: _vm.overlay,
      position: _vm.position
    },
    model: {
      value: _vm.showPicker,
      callback: function callback($$v) {
        _vm.showPicker = $$v;
      },
      expression: "showPicker"
    }
  }, [_c("van-picker", {
    attrs: {
      "show-toolbar": "",
      columns: _vm.columns
    },
    on: {
      confirm: _vm.handleConfirmSelect,
      cancel: function cancel($event) {
        _vm.showPicker = false;
      }
    }
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;